import { Grid } from "@material-ui/core";
import DoneOutlineIcon from "@material-ui/icons/DoneOutline";
import { push } from "connected-react-router";
import moment from "moment";
import "moment/locale/es";
import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";
import {
  formatPhoneNumber,
  isValidPhoneNumber,
} from "react-phone-number-input";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import {
  SERVICE_STATE,
  TGetServicesCollectionItem,
} from "../../../../../../api/service/service.types";
import AvatarIcon from "../../../../../../assets/images/iconos/avatar.png";
import BadgeIcon from "../../../../../../assets/images/iconos/badge.png";
import CalendarIcon from "../../../../../../assets/images/iconos/calendar.png";
import HorarioIcon from "../../../../../../components/CuideoIcons/HorarioIcon.svg";
import MoneyIcon from "../../../../../../components/CuideoIcons/MoneyIcon.svg";
import WarningIcon from "../../../../../../assets/images/iconos/yellow-warning.png";
import { formatCurrency } from "../../../../../../util/formatNumbers";
import useStandarizedServiceTitle from "../../../../../../util/Service/useStandarizedServiceTitle";
import ServiceType from "../../../../components/ServiceType";
import {
  serviceCanBeDelayed,
  serviceCanBeValuedByUser,
  serviceIsSelection,
} from "../../../../models/Service/Service";
import { TStaff } from "../../../../models/Staff/Staff";
import ServiceExpressTag from "../../../../pages/ServicePage/components/ServiceExpressTag";
import DelayButton from "../../../../pages/ServicesPage/components/DelayButton";
import { serviceCommercialNotes } from "../../util/service.util";
import {
  StyledBottomInfoLine,
  StyledCard,
  StyledCardButton,
  StyledClickablePhoneNumber,
  StyledCreated,
  StyledEmptyGeneralReport,
  StyledFirstRow,
  StyledGeneralReport,
  StyledGeneralReportTitle,
  StyledGeneralReportWrapper,
  StyledIcon,
  StyledItem,
  StyledItemDetail,
  StyledItemMoneyDetail,
  StyledSecondRow,
  StyledServiceDetails,
  StyledServiceInfo,
  StyledServiceName,
  StyledServiceRight,
  StyledServiceRightBottom,
  StyledServiceRightBottomLeft,
  StyledServiceRightBottomRight,
  StyledServiceRightTop,
  StyledServiceRightTopLeft,
  StyledServiceRightTopRight,
  StyledServiceStatus,
  StyledServiceTitle,
  StyledServiceTitleDetails,
  StyledThirdRow,
  StyledTriData,
  StyledTriDataWrapper,
  StyledTriIcon,
  StyledTriItem,
  StyledTriLabel,
} from "./ServiceCardSC";
import ServiceLocation from "./ServiceLocation";
import ServicePlanTag from "./ServicePlanTag";

const StyledDelayButtonWrapper = styled.div`
  margin: 1rem 0;
`;

interface IServiceCardProps {
  service: TGetServicesCollectionItem;
  onDelaySet: () => void;
}

const ServiceCard = (props: IServiceCardProps) => {
  const { service, onDelaySet } = props;
  const authUser = useSelector((state: any) => state.auth.authUser);
  const dispatch = useDispatch();
  const serviceTitle = useStandarizedServiceTitle(service);

  const handleCardClick = () => {
    dispatch(push(encodeURI(`/service/${service.id}`)));
  };

  const handleEditValuationClick = () => {
    dispatch(push(encodeURI(`/service/${service.id}/edit-valuation`)));
  };

  return (
    <StyledCard
      className={service.valuationInProcess ? "valuation-in-progress" : ""}
    >
      <StyledServiceInfo>
        <StyledFirstRow>
          <StyledCreated>
            <FormattedMessage
              id="ServiceCard.Created"
              defaultMessage="Servicio creado el {date}"
              values={{ date: moment(service.createdAt).format("DD/MM/YYYY") }}
            />
          </StyledCreated>
        </StyledFirstRow>
        <StyledSecondRow>
          <StyledServiceTitleDetails>
            <ServiceType
              serviceType={service.Tipo_de_Servicio}
              serviceDealType={service.Tipo_de_Trato}
            />
            <StyledServiceTitle>{serviceTitle}</StyledServiceTitle>
          </StyledServiceTitleDetails>
          <StyledServiceDetails>
            <StyledServiceName>{service.Name}</StyledServiceName>
            <StyledServiceStatus>
              <FormattedMessage
                id="ServiceCard.Status"
                defaultMessage="Estado: {status}"
                values={{ status: service.Estado_Servicio }}
              />
            </StyledServiceStatus>
          </StyledServiceDetails>
        </StyledSecondRow>
        <StyledThirdRow>
          <Grid container spacing={8}>
            <Grid item xs={12} sm={6}>
              {serviceIsSelection(service) && (
                <StyledItem>
                  <StyledIcon src={MoneyIcon} />
                  <StyledItemMoneyDetail>
                    {service.Salario_Bruto ? (
                      <Fragment>
                        {formatCurrency(service.Salario_Bruto)}
                      </Fragment>
                    ) : (
                      <Fragment>
                        <FormattedMessage
                          id="ServiceCard.NotReported"
                          defaultMessage="No indicado"
                        />
                      </Fragment>
                    )}
                    {service.Tipo_de_salario &&
                      service.Tipo_de_salario === "Mensual" && (
                        <FormattedMessage
                          id="ServiceCard.MonthSuffix"
                          defaultMessage="/mes"
                        />
                      )}
                    {service.Tipo_de_salario &&
                      service.Tipo_de_salario === "Diario" && (
                        <FormattedMessage
                          id="ServiceCard.DaySuffix"
                          defaultMessage="/día"
                        />
                      )}
                  </StyledItemMoneyDetail>
                </StyledItem>
              )}
              <StyledItem>
                <ServiceLocation
                  locality={service.Ciudad}
                  region={service.Provincia}
                />
              </StyledItem>
              {service.Horario_Servicio && (
                <StyledItem>
                  <StyledIcon src={HorarioIcon}></StyledIcon>
                  <StyledItemDetail>
                    {service.Horario_Servicio}
                  </StyledItemDetail>
                </StyledItem>
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              <StyledItem>
                <StyledIcon src={AvatarIcon}></StyledIcon>
                <StyledItemDetail>
                  {service.customer?.First_Name} {service.customer?.Last_Name},
                  {isValidPhoneNumber(service.customer?.Phone) ? (
                    <StyledClickablePhoneNumber
                      href={`tel:${service.customer?.Phone}`}
                    >
                      {service.customer?.Phone}
                    </StyledClickablePhoneNumber>
                  ) : (
                    formatPhoneNumber(service.customer?.Phone)
                  )}
                </StyledItemDetail>
              </StyledItem>
              {service.Zona_sin_base && (
                <StyledItem>
                  <StyledIcon src={WarningIcon}></StyledIcon>
                  <StyledItemDetail>
                    <FormattedMessage
                      id="ServiceCard.Zona sin base"
                      defaultMessage="Zona sin base"
                    />
                  </StyledItemDetail>
                </StyledItem>
              )}
            </Grid>
          </Grid>
        </StyledThirdRow>
        <StyledBottomInfoLine>
          <ServicePlanTag service={service} />
          <ServiceExpressTag service={service} />
        </StyledBottomInfoLine>
      </StyledServiceInfo>
      <StyledServiceRight>
        <StyledServiceRightTop>
          <StyledServiceRightTopLeft></StyledServiceRightTopLeft>
          <StyledServiceRightTopRight>
            {service.Estado_Servicio === SERVICE_STATE.CLOSED &&
              !!service.Cerrado_Contratadodate && (
                <StyledTriItem>
                  <StyledTriIcon src={CalendarIcon} />
                  <StyledTriDataWrapper>
                    <StyledTriLabel>
                      <FormattedMessage
                        id="ServiceCard.Fecha Contratado"
                        defaultMessage="Fecha contratado"
                      />
                    </StyledTriLabel>
                    <StyledTriData>
                      {moment(service.Cerrado_Contratadodate).format(
                        "DD/MM/YYYY"
                      )}
                    </StyledTriData>
                  </StyledTriDataWrapper>
                </StyledTriItem>
              )}
            <StyledTriItem>
              <StyledTriIcon src={BadgeIcon} />
              <StyledTriDataWrapper>
                <StyledTriLabel>
                  <FormattedMessage
                    id="ServiceCard.Comercial"
                    defaultMessage="Comercial"
                  />
                </StyledTriLabel>
                <StyledTriData>
                  {service.Venta_relacionada?.ownerName}
                </StyledTriData>
              </StyledTriDataWrapper>
            </StyledTriItem>
            <StyledTriItem>
              <StyledTriIcon src={BadgeIcon} />
              <StyledTriDataWrapper>
                <StyledTriLabel>
                  <FormattedMessage
                    id="ServiceCard.Owner"
                    defaultMessage="Propietario"
                  />
                </StyledTriLabel>
                <StyledTriData>{service.ownerName}</StyledTriData>
              </StyledTriDataWrapper>
            </StyledTriItem>
          </StyledServiceRightTopRight>
        </StyledServiceRightTop>
        <StyledServiceRightBottom>
          <StyledServiceRightBottomLeft>
            <StyledGeneralReportWrapper>
              <StyledGeneralReportTitle>
                <FormattedMessage
                  id="ServiceCard.CommercialDptNotes"
                  defaultMessage="Notas departamento comercial"
                />
              </StyledGeneralReportTitle>
              {serviceCommercialNotes(service) ? (
                <StyledGeneralReport>
                  {serviceCommercialNotes(service)}
                </StyledGeneralReport>
              ) : (
                <StyledEmptyGeneralReport>
                  <FormattedMessage
                    id="ServiceCard.NoCommercialDptNotes"
                    defaultMessage="Sin notas departamento comercial"
                  />
                </StyledEmptyGeneralReport>
              )}
            </StyledGeneralReportWrapper>
          </StyledServiceRightBottomLeft>
          <StyledServiceRightBottomRight>
            {serviceCanBeDelayed(service) && (
              <StyledDelayButtonWrapper>
                <DelayButton
                  delayDate={service.delayedDate ?? null}
                  delayReason={service.delayedReason ?? null}
                  onDelaySet={onDelaySet}
                  serviceId={service.id}
                  serviceName={service.Name ?? null}
                />
              </StyledDelayButtonWrapper>
            )}
            {serviceCanBeValuedByUser(service, authUser as TStaff) && (
              <StyledCardButton
                size="large"
                color="primary"
                variant="contained"
                onClick={handleEditValuationClick}
                className="CMuiServiceCardButton"
              >
                <FormattedMessage
                  id="ServiceCard.Editar valoración"
                  defaultMessage="Editar valoración"
                />
              </StyledCardButton>
            )}
            {service.Estado_Servicio === SERVICE_STATE.WITHOUT_VALIDATION && (
              <Fragment>
                <StyledCardButton
                  size="large"
                  color={service.valuationInProcess ? "secondary" : "primary"}
                  variant="contained"
                  startIcon={
                    service.valuationInProcess ? undefined : <DoneOutlineIcon />
                  }
                  onClick={handleCardClick}
                  className="CMuiServiceCardButton"
                >
                  {service.valuationInProcess ? (
                    <FormattedMessage
                      id="ServiceCard.ContinueValidation"
                      defaultMessage="Continuar valoración"
                    />
                  ) : (
                    <FormattedMessage
                      id="ServiceCard.Validate"
                      defaultMessage="Empezar valoración"
                    />
                  )}
                </StyledCardButton>
              </Fragment>
            )}
          </StyledServiceRightBottomRight>
        </StyledServiceRightBottom>
      </StyledServiceRight>
    </StyledCard>
  );
};

export default ServiceCard;
